"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TextInherited = void 0;
var _createText = require("./createText");
const TextInherited = (0, _createText.createText)('body', {
  inherit: true
});
exports.TextInherited = TextInherited;